import { AnalyticsPlugin } from '@pulse/common';
import {
    LocationHistoryTracker,
    NavigationEventService,
    SessionService,
    TrackingConsentService,
} from '../../services';

export class NavigationEventPlugin implements AnalyticsPlugin {
    constructor(
        private historyTracker: LocationHistoryTracker,
        private navigationEventService: NavigationEventService,
        private sessionService: SessionService,
        private consentService: TrackingConsentService,
    ) {}

    init() {
        this.navigationEventService.send(true);

        this.sessionService.session.subscribe((session) => {
            if ((session.isRenew || session?.renewedBy) && this.consentService.trackingEnabled()) {
                this.navigationEventService.send(false, session?.renewedBy);
            }
        });

        this.historyTracker.navigation.subscribe(() => this.navigationEventService.send(false));
    }
}
